import { inApp } from '@w/utils/system';
import { type } from '@w/utils/common';
import urlExt from '@w/utils/url';
import { hybrid, canUseCommon, pageTo } from '@kd/hybrid';

interface naOptions {
  pageUrl: string;
  hideStatusBar: number;
  hideNavBar: number;
  title?: string;
}
interface RouteOptions {
  module?: string;
  name?: string;
  appName?: string;
  params?: { [key: string]: unknown };
  query?: { [key: string]: unknown };
  options?: naOptions;
}

// describe('route', () => {
//   it('zyb route works', () => {
//     expect(zybRoute('search')).toEqual('zyb://app-vue/page/about#/search');
//     expect(zybRoute('search?a=1')).toEqual(
//       'zyb://app-vue/page/about#/search?a=1'
//     );
//     expect(zybRoute('?a=1#/search')).toEqual(
//       'zyb://app-vue/page/about?a=1#/search'
//     );
//     expect(zybRoute('search')).toEqual('zyb://app-vue/page/about#/search');
//     expect(zybRoute('search?a=1')).toEqual(
//       'zyb://app-vue/page/about#/search?a=1'
//     );
//     expect(zybRoute('?a=1#/search')).toEqual(
//       'zyb://app-vue/page/about?a=1#/search'
//     );
//     expect(zybRoute({ name: 'search' })).toEqual(
//       'zyb://app-vue/page/about#/search'
//     );
//     expect(zybRoute({ module: 'newspaper' })).toEqual(
//       'zyb://app-vue/page/newspaper'
//     );
//     expect(zybRoute({ module: 'newspaper', name: 'search' })).toEqual(
//       'zyb://app-vue/page/newspaper#/search'
//     );
//     expect(zybRoute({ module: 'newspaper', name: 'search?a=1' })).toEqual(
//       'zyb://app-vue/page/newspaper#/search?a=1'
//     );
//     expect(zybRoute({ module: 'newspaper', name: '?a=1#/search' })).toEqual(
//       'zyb://app-vue/page/newspaper?a=1#/search'
//     );
//     expect(zybRoute({ query: { a: 1, b: 2 } })).toEqual(
//       'zyb://app-vue/page/about?a=1&b=2'
//     );
//     expect(zybRoute({ params: { a: 1, b: 2 } })).toEqual(
//       'zyb://app-vue/page/about?a=1&b=2'
//     );
//     expect(zybRoute({ module: 'newspaper', query: { a: 1, b: 2 } })).toEqual(
//       'zyb://app-vue/page/newspaper?a=1&b=2'
//     );
//     expect(zybRoute({ module: 'newspaper', params: { a: 1, b: 2 } })).toEqual(
//       'zyb://app-vue/page/newspaper?a=1&b=2'
//     );
//     expect(zybRoute({ name: 'search', query: { a: 1, b: 2 } })).toEqual(
//       'zyb://app-vue/page/about#/search?a=1&b=2'
//     );
//     expect(zybRoute({ name: 'search', params: { a: 1, b: 2 } })).toEqual(
//       'zyb://app-vue/page/about?a=1&b=2#/search'
//     );
//     expect(
//       zybRoute({ module: 'newspaper', name: 'search', query: { a: 1, b: 2 } })
//     ).toEqual('zyb://app-vue/page/newspaper#/search?a=1&b=2');
//     expect(
//       zybRoute({ module: 'newspaper', name: 'search', params: { a: 1, b: 2 } })
//     ).toEqual('zyb://app-vue/page/newspaper?a=1&b=2#/search');
//   });

//   it('url route works', () => {
//     expect(urlRoute('search')).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html#/search'
//     );
//     expect(urlRoute('search?a=1')).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html#/search?a=1'
//     );
//     expect(urlRoute('?a=1#/search')).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html?a=1#/search'
//     );
//     expect(urlRoute('search')).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html#/search'
//     );
//     expect(urlRoute('search?a=1')).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html#/search?a=1'
//     );
//     expect(urlRoute('?a=1#/search')).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html?a=1#/search'
//     );
//     expect(urlRoute({ name: 'search' })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html#/search'
//     );
//     expect(urlRoute({ module: 'newspaper' })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/newspaper.html'
//     );
//     expect(urlRoute({ module: 'newspaper', name: 'search' })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/newspaper.html#/search'
//     );
//     expect(urlRoute({ module: 'newspaper', name: 'search?a=1' })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/newspaper.html#/search?a=1'
//     );
//     expect(urlRoute({ module: 'newspaper', name: '?a=1#/search' })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/newspaper.html?a=1#/search'
//     );
//     expect(urlRoute({ query: { a: 1, b: 2 } })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html?a=1&b=2'
//     );
//     expect(urlRoute({ params: { a: 1, b: 2 } })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html?a=1&b=2'
//     );
//     expect(urlRoute({ module: 'newspaper', query: { a: 1, b: 2 } })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/newspaper.html?a=1&b=2'
//     );
//     expect(urlRoute({ module: 'newspaper', params: { a: 1, b: 2 } })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/newspaper.html?a=1&b=2'
//     );
//     expect(urlRoute({ name: 'search', query: { a: 1, b: 2 } })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html#/search?a=1&b=2'
//     );
//     expect(urlRoute({ name: 'search', params: { a: 1, b: 2 } })).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html?a=1&b=2#/search'
//     );
//     expect(
//       urlRoute({ module: 'newspaper', name: 'search', query: { a: 1, b: 2 } })
//     ).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/newspaper.html#/search?a=1&b=2'
//     );
//     expect(
//       urlRoute({ module: 'newspaper', name: 'search', params: { a: 1, b: 2 } })
//     ).toEqual(
//       'https://www.kuaiduizuoye.com/static/hy/app-vue/newspaper.html?a=1&b=2#/search'
//     );
//   });
// });

const origin = location.origin;
const href = location.href;
const isLocal = /(localhost|127.0.0.1|10.250.\d{2,3}.\d{2,3})/.test(href);
const originMatched = /([^:]+):\/\/([^/]+)\//.exec(href);
const protocal = originMatched !== null ? originMatched[1] : 'https';
const host = originMatched !== null ? originMatched[2] : origin;
const naBaseParams = {
  hideStatusBar: 0,
  hideNavBar: 0
};

const optionFormat = (opts: { [key: string]: unknown }): { [key: string]: unknown } =>
  type(opts) === 'string' ? { name: opts } : opts;

const resolveModule = (url: string): string => {
  const moduleHashMatch = /\/([^/.]+)\.html/.exec(url);
  const moduleMatch = moduleHashMatch ? moduleHashMatch[1] : '';
  const pureModule =
    moduleMatch && moduleMatch.match('hycache') !== null
      ? /(.+)-[^-.]{8}-hycache/g.exec(moduleMatch)
      : ['', moduleMatch];
  return pureModule ? pureModule[1] : '';
};

const resolveName = (rawName: string): string => {
  const hasParams = /^\?/.exec(rawName) !== null;
  return hasParams ? rawName : `#/${rawName}`;
};

const resolveExt = (rawExt: { [key: string]: unknown }): unknown => urlExt.jsonToQuery(rawExt, false);

export function naRoute(options: naOptions): void {
  console.log('core_openWindow', options);
  hybrid('core_openWindow', {
    ...naBaseParams,
    ...options
  });
}

export function feRoute(routeOpts: { [key: string]: any }): void {
  // eslint-disable-line
  console.log('feRedirect', routeOpts);
  location.href = routeOpts.options.pageUrl;
}

export function zybRoute(zybUrl: string, router: string, options: naOptions): void {
  console.log('pageTo', {
    ...options,
    pageUrl: zybUrl,
    url: zybUrl,
    params: router
  });
  pageTo({
    // eslint-disable-line
    ...options,
    pageUrl: zybUrl,
    url: zybUrl,
    params: router
  });
}

export function route(opts: RouteOptions | string): void {
  let routeOpts: RouteOptions = optionFormat(opts as any); // eslint-disable-line
  // 页面名称
  const module = (routeOpts.module = routeOpts.module || resolveModule(href));
  // 路由解析
  const useRouter = 'name' in routeOpts;
  const name = useRouter ? resolveName(routeOpts.name as any) : ''; // eslint-disable-line
  // params解析
  const useParams = 'params' in routeOpts;
  const params = useParams ? '?' + resolveExt(routeOpts.params as any) : ''; // eslint-disable-line
  // query解析
  const useQuery = 'query' in routeOpts;
  const query = useQuery ? '?' + resolveExt(routeOpts.query as any) : ''; // eslint-disable-line
  // 附属参数拼接
  const extStr = `${params}${name}${query}`;
  // zyb链接
  const appName = routeOpts.appName ? routeOpts.appName : 'app-vue';
  const zybUrl = `zyb://${appName}/page/${module}${extStr}`;
  // url链接
  const pageUrl = `${protocal}://${host}${isLocal ? '/' : `/static/hy/${appName}/`}${module}.html${extStr}`;
  routeOpts.options = {
    pageUrl,
    ...naBaseParams,
    ...routeOpts.options
  };
  if (inApp && canUseCommon('pageTo') && !isLocal) {
    // eslint-disable-line
    zybRoute(zybUrl, extStr, routeOpts.options);
  } else if (!inApp) {
    feRoute(routeOpts);
  } else {
    naRoute(routeOpts.options);
  }
}
